/* eslint-disable no-console */
import axios from 'axios';
import moment from 'moment';

import {downPropertyKey} from '../../../components/Forms/Constants/IP/dSPropertyKeyLabel';
import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import useUserStore from '../../../store/userStore/userStore';
import {APIType, APITypeEnum} from '../../interface/tableAPIType';
import {getRouteIP, tableAPIMethod} from '../../utils/tableAPIMethod';

const listingDownstreamLeasedAPI = async (
  type: APIType,
  data: any = undefined,
  id: string = '',
  section: 'valueChain' | 'dataCollection' = 'valueChain'
): Promise<any> => {
  const token = useUserStore.getState().userToken;

  try {
    const response = await axios.request({
      method: tableAPIMethod(type),
      url: `${API_BASE_URL}${
        section === 'valueChain'
          ? API_ENDPOINT_JSON.downstreamLeasedAsset_valueChain
          : API_ENDPOINT_JSON.downstreamLeasedAsset_dataCollection
      }/${getRouteIP(type, id)}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {},
      data: data ?? {}
    });

    if (type === APITypeEnum.GET_ALL) {
      const mainRes = response.data.data.map((item: any) => {
        return {
          ...item,
          [downPropertyKey.RENTED_FROM]: item?.[downPropertyKey.RENTED_FROM]
            ? moment(item?.[downPropertyKey.RENTED_FROM])
            : undefined,
          [downPropertyKey.RENTED_TO]: item?.[downPropertyKey.RENTED_TO]
            ? moment(item?.[downPropertyKey.RENTED_TO])
            : undefined
        };
      });

      return mainRes;
    } else {
      return response.data;
    }
  } catch (err) {
    console.log('err:', err);
  }
};

export default listingDownstreamLeasedAPI;
